"use client";

import { FC, useMemo } from "react";
import { useTranslations } from "next-intl";
import { Image } from "react-datocms";

import { IResponsiveImage, IDatoGeneralMeta } from "@types";
import { SLUGS } from "consts";

import { Button } from "components/atoms/Button/Button";
import { Newsletter } from "components/molecules/Newsletter/Newsletter";

import s from "./Doormat.module.scss";
import { useOfficeContactPrefillQuery } from "context/OfficeContactPrefillContext";
import { appendOfficeContactQueryToHref } from "utils/officeContact";

interface Props {
  doormatImage: IResponsiveImage | null;
  general: IDatoGeneralMeta;
}

export const Doormat: FC<Props> = ({ doormatImage, general }) => {
  const t = useTranslations("common");
  const contactPrefill = useOfficeContactPrefillQuery();

  const contactLinkHref = useMemo(() => {
    const baseHref = `${SLUGS.contactGeneral}?is_service=true`;
    if (!contactPrefill) {
      return baseHref;
    }
    return appendOfficeContactQueryToHref(baseHref, contactPrefill);
  }, [contactPrefill]);

  return (
    <div className={s.Doormat}>
      {doormatImage && (
        <Image data={doormatImage.responsiveImage} layout="responsive" className={s.Image} />
      )}
      <div className={s.Inner}>
        <div className={s.Cta}>
          <div className={s.CtaContent}>
            <p>
              <strong>{t("learn-more-about-services")}</strong>{" "}
            </p>
            <p>{t("we-love-to-help-you")}.</p>
          </div>
          <Button label={t("contact-us")} link={{ href: contactLinkHref }} />
        </div>
        <Newsletter general={general} />
      </div>
    </div>
  );
};
